module.exports = __webpack_public_path__ + "static/media/honda-app-icon.142c078f.svg";